window.globalHelpersModule.directive "noPpraMessage", 
['$rootScope', '$log', '$timeout', '$state', ($rootScope, $log, $timeout, $state) ->
  restrict: "E"

  link: (scope, element, attrs) ->
    scope.currentState = $state.current.name

  templateUrl: 'portal/no-ppra-message/no-ppra-message-directive-template.html'
]